import styled from 'styled-components';

export const BellContainer = styled.div`
  position: relative;
`;

export const BellIcon = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const Badge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  background: #c71618;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 999;
  overflow: hidden;
  
  @media (max-width: 480px) {
    width: calc(100vw - 32px);
    right: -16px;
  }
`;

export const NotificationItem = styled.div<{ unread: boolean }>`
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
  background: ${(props) => (props.unread ? '#f0f7ff' : 'white')};
  
  &:hover {
    background: #f9f9f9;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const NotificationTitle = styled.div`
  font-weight: 600;
  color: #333;
  font-size: 14px;
  margin-bottom: 4px;
`;

export const NotificationBody = styled.div`
  color: #666;
  font-size: 13px;
  margin-bottom: 4px;
  line-height: 1.4;
`;

export const NotificationTime = styled.div`
  font-size: 11px;
  color: #999;
`;

export const EmptyState = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
`;
